<template>
  <div class="relative">
    <LoadingSpinner v-if="getLoading" class="h-screen w-screen" />
    <!-- <POMButton v-if="isLoggedIn" /> -->
    <POMDialog v-if="isLoggedIn" />
    <ParticipantPotm />
    <div :class="`w-full pa-0 ma-0 ${routeLink ? routeLink + '-BG' : ''}`">
      <v-btn
        dark
        icon
        small
        rounded
        @click.prevent="dialogNavigation = true"
        :color="`${routeType}primary`"
        class="mobileNavBtn"
        v-if="!dialogNavigation && isMobile && navig && routeLink"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
      <v-btn
        dark
        large
        elevation="2"
        v-if="tutorial"
        :color="`${routeType}primary`"
        class="skipButton"
        @click.prevent="skipTutorial"
        >done</v-btn
      >
      <v-overlay
        z-index="99"
        v-touch="{
          left: () => tutorialSwipe('left'),
          right: () => tutorialSwipe('right'),
        }"
        :value="tutorial"
      >
        <v-row class="px-5 fill-height ma-0" align="center" justify="center">
          <p class="h3">{{ tutorialText }}</p>
          <v-btn icon color="grey" x-large :class="tutorialClass">
            <v-icon>{{ tutorialIcon }}</v-icon>
          </v-btn>
        </v-row>
      </v-overlay>
      <v-overlay z-index="999" :value="$store.getters.getLocker" opacity="1">
        <v-row class="px-5 fill-height ma-0 !flex-col" align="center" justify="center">
          <v-expand-transition>
            <v-progress-circular
              v-if="!unlockingAttempt && !forgetPasswordInput"
              :rotate="-90"
              :size="100"
              :width="15"
              :value="radialValue"
              :color="`${routeType}primary`"
            >
              <v-btn
                icon
                @mousedown="unlockHold"
                @mouseup="unlockClickLift"
                @touchstart="unlockHold"
                @touchend="unlockClickLift"
              >
                <v-icon>mdi-lock-open</v-icon>
              </v-btn>
            </v-progress-circular>
          </v-expand-transition>

          <v-expand-transition>
            <div class="" v-if="unlockingAttempt">
              <p class="text-slate-300 font-Handel">Enter Your 5 Digit Lock Screen Pin</p>
              <v-otp-input
                v-model="enteredPinCode"
                class="otp_verify font-Handel"
                type="password"
                length="5"
                @finish="verifyingPinCode"
              ></v-otp-input>
              <v-btn :color="colorAsRoute" text dark @click="forgetPassword()"
                >Forgot Pin Code?
              </v-btn>
            </div>
          </v-expand-transition>
          <v-expand-transition>
            <div class="" v-if="forgetPasswordInput && !authSuccess">
              <p class="text-slate-300 font-Handel">
                Enter Your Email Address and Password
              </p>
              <v-text-field
                v-model="email"
                :rules="[(v) => !!v || 'Email is required']"
                outlined
                disabled
                class="border-0 !rounded-none text-red !text-sm font-Handel"
                :color="colorAsRoute"
                dark
                placeholder="Enter Your Email Address"
                required
              ></v-text-field>
              <v-text-field
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                :rules="[(v) => !!v || 'Password is required']"
                outlined
                class="border-0 !rounded-none text-red !text-sm font-Handel"
                :color="colorAsRoute"
                dark
                placeholder="Enter Your Password"
                required
              ></v-text-field>
              <v-btn
                outlined
                :color="colorAsRoute"
                block
                :loading="verfiyUserLoading"
                @click="verifyUser"
                >Forgot Pin Code</v-btn
              >
            </div>
          </v-expand-transition>
          <v-expand-transition>
            <div v-if="authSuccess">
              <p class="text-slate-300 font-Handel">Set New Pin Code</p>
              <v-otp-input
                v-model="newPinCode"
                class="otp_verify font-Handel"
                type="password"
                length="5"
                @finish="setNewPin"
              ></v-otp-input>
            </div>
          </v-expand-transition>
        </v-row>
      </v-overlay>
      <v-btn
        v-if="isMobile && routeLink"
        :color="`${routeType}warning`"
        dark
        fab
        icon
        small
        @click.prevent="lockScreenHandler"
        class="lockButton"
      >
        <v-img
          class="rounded-full"
          max-width="40"
          :src="require(`@/assets/img/nav-icons/${routeLink}/lock.png`)"
          alt=""
        />
      </v-btn>
      <!-- <Premium v-if="isLoggedIn" /> -->
      <SpotifyButton
        v-if="!premium && isLoggedIn && !isMobile && !leftSectionRouteDisabler"
      />

      <v-row v-if="isMobile && navig && routeLink">
        <v-col>
          <v-dialog
            v-model="dialogNavigation"
            fullscreen
            hide-overlay
            scrollable
            transition="fade-transition"
          >
            <MobileNav
              @nav-close="dialogNavigation = false"
              @show-tutorial="showTutorial"
            />
          </v-dialog>
        </v-col>
      </v-row>
      <div
        v-touch="{ left: () => swipe('left'), right: () => swipe('right') }"
        no-gutters
        class="pa-0 ma-0 d-flex w-full"
      >
        <div class="flex">
          <Left
            v-if="!isMobile || leftV"
            class="sm:block xs:hidden sm:w-[33.33%] w-full"
            :navig="navig"
          />
          <div
            :class="`w-full h-screen pa-0 ma-0 ${
              leftSectionRouteDisabler ? 'sm:w-full' : 'sm:w-[calc(66.67%-100px)]'
            }`"
            v-if="!isMobile || centerV || rightV"
          >
            <router-view></router-view>
          </div>
          <div
            class="align-center h-screen w-[100px] justify-self-end pa-0 ma-0 xs:flex hidden"
            v-if="navig"
          >
            <Nav @lock-app="lockScreenHandler" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Left from "../sections/Left.vue";
import Middle from "../sections/Middle.vue";
import Right from "../sections/Right.vue";
import Nav from "../../components/navigation/Nav.vue";
import MobileNav from "../../components/navigation/MobileNav.vue";
import { getKeyByValue } from "../../utility";
import MiniPlayer from "../../components/musicplayer/MiniPlayer.vue";
import { CometChat } from "@cometchat-pro/chat";
import Premium from "@/components/Premium.vue";
import SpotifyButton from "@/components/SpotifyButton.vue";
import LoadingSpinner from "@/pages/front/straight/childs/LoadingSpinner.vue";
import POMButton from "@/components/POMButton.vue";
import POMDialog from "@/components/POMDialog.vue";
import ParticipantPotm from "@/components/ParticipantPotm.vue";
import axios from "axios";
import errors from "@/store/modules/errors";
import Player from "@/components/musicplayer/player.vue";

export default {
  name: "Base",
  components: {
    Left,
    Middle,
    Right,
    Nav,
    MobileNav,
    MiniPlayer,
    Premium,
    SpotifyButton,
    LoadingSpinner,
    POMButton,
    POMDialog,
    ParticipantPotm,
    Player,
  },
  computed: {
    getLoading() {
      return this.$store.getters.isLoading;
    },
    getLockPinStatus() {
      return this.$store.getters.StateUser.data.pincode_status;
    },
    colorAsRoute() {
      if (this.routeLink == "straight") {
        return "#a07a1d";
      } else if (this.routeLink == "gay") {
        return "#88c3fa";
      } else if (this.routeLink == "lesbian") {
        return "#9e2eec";
      }
    },
    navig() {
      const rightV = this.$route.meta.naviView;
      if (rightV === undefined) {
        return true;
      }
      return rightV;
    },
    premium() {
      return this.$store.getters.isPremium;
    },
    profileRouteChecker() {
      return this.$route.name === "Profiles";
    },
    leftSectionRouteDisabler() {
      return (
        this.$route.name === "Plan" ||
        this.$route.name === "Interest" ||
        this.$route.name === "Login" ||
        this.$route.name === "Register" ||
        this.$route.name === "Verify" ||
        this.$route.name === "Completeprofile" ||
        this.$route.name === "Notfound" ||
        this.$route.name === "Forgotpassword"
      );
    },
  },
  data() {
    return {
      userInteraction: false,
      dialogNavigation: false,
      filterDialog: false,
      tutorial: false,
      tutorialText: "Swipe left or right to view side sections",
      tutorialIcon: "mdi-gesture-swipe",
      tutorialClass: "swipeBoth",
      // locker data
      unlockingAttempt: false,
      forgetPasswordInput: false,
      enteredPinCode: null,
      timer: null,
      counter: null,
      radialValue: 0,
      spaceChecker: true,
      // locker pin forgot
      showPassword: false,
      email: this.$store.getters.StateUser.data.email,
      password: "",
      authSuccess: false,
      verfiyUserLoading: false,
      newPinCode: null,
    };
  },
  methods: {
    lockScreenHandler() {
      if (!this.$store.getters.StateUser.data.pincode_status) {
        this.$toast("Set Your Lock Screen Pin First", {
          position: "top-center",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: true,
          hideProgressBar: true,
          closeButton: "button",
          icon: {
            iconClass: "mdi mdi-alert-circle-outline",
            iconChildren: "",
            iconTag: "i",
          },
          rtl: false,
        });
      }
      this.$store.dispatch("Locker");
      this.setCenterView();
    },
    forgetPassword() {
      this.unlockingAttempt = false;
      this.forgetPasswordInput = true;
    },
    async setNewPin() {
      const resp = await axios.post("users/pincode", { pincode: this.newPinCode });
      if (resp.data.status == "Success") {
        this.$toast(resp.data.message, {
          position: "top-left",
          timeout: 3000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          closeButton: "button",
          icon: {
            iconClass: "mdi mdi-checkbox-multiple-marked-outline",
            iconChildren: "",
            iconTag: "i",
          },
          rtl: false,
        });
        this.$store.dispatch("Locker");
        this.authSuccess = false;
        this.newPinCode = null;
        this.forgetPasswordInput = false;
      }
    },
    async verifyUser() {
      try {
        this.verfiyUserLoading = true;
        const user = await axios.post("auth/login", {
          email: this.email,
          password: this.password,
        });
        if (user.status == 200) {
          this.authSuccess = true;
        }
        console.log(user);
      } catch (error) {
        console.log(error);
      } finally {
        this.verfiyUserLoading = false;
      }
    },
    swipe(direction) {
      if (
        this.$route.name === "Plan" ||
        this.$route.name === "Interest" ||
        this.$route.name === "Login" ||
        this.$route.name === "Register" ||
        this.$route.name === "Verify" ||
        this.$route.name === "Completeprofile" ||
        this.$route.name === "Notfound" ||
        this.$route.name === "Forgotpassword"
      ) {
        return;
      }
      const currView = this.$store.getters.currentView;
      const key = getKeyByValue(currView, "block");
      const leftEnabled = {
        left: "block",
        center: "none",
        right: "none",
      };
      const centerEnabled = {
        left: "none",
        center: "block",
        right: "none",
      };
      const rightEnabled = {
        left: "none",
        center: "none",
        right: "block",
      };
      if (direction === "left") {
        if (key === "left") {
          this.$store.dispatch("setView", centerEnabled);
        } else if (key === "center" || key === "right") {
          this.$store.dispatch("setView", rightEnabled);
        }
      } else if (direction === "right") {
        if (key === "left" || key === "center") {
          this.$store.dispatch("setView", leftEnabled);
        } else if (key === "right") {
          this.$store.dispatch("setView", centerEnabled);
        }
      }
    },
    tutorialSwipe(direction) {
      const currView = this.$store.getters.currentView;
      const key = getKeyByValue(currView, "block");
      if (direction === "right" && key === "center") {
        this.tutorialText = "Swipe left to view center part";
        this.tutorialIcon = "mdi-gesture-swipe-left";
        this.tutorialClass = "swipeLeft";
        this.swipe(direction);
      } else if (direction === "left" && key === "center") {
        this.tutorialText = "Swipe right to view center part";
        this.tutorialIcon = "mdi-gesture-swipe-right";
        this.tutorialClass = "swipeRight";
        this.swipe(direction);
      } else {
        this.tutorialText = "Swipe left or right";
        this.tutorialIcon = "mdi-gesture-swipe";
        this.tutorialClass = "swipeBoth";
        this.swipe(direction);
      }
    },
    showTutorial() {
      this.dialogNavigation = false;
      this.$router.push({ name: "Tutorial" });
      this.tutorial = true;
    },
    skipTutorial() {
      this.tutorial = false;
      this.$router.push({ name: "Profiles" });
      this.setCenterView();
    },
    unlockHold() {
      this.timer = setTimeout(() => {
        this.unlockingAttempt = true;
        return this.unlockClickLift();
      }, 800);
      this.counter = setInterval(() => {
        this.radialValue = 100;
      }, 100);
    },
    async verifyingPinCode() {
      try {
        this.$store.dispatch("setloading", true);
        const resp = await axios.post("users/verify/pincode", {
          pincode: this.enteredPinCode,
        });
        console.log(resp);
        if (resp.data.status == "Success") {
          this.$toast(resp.data.message, {
            position: "top-left",
            timeout: 3000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: "button",
            icon: {
              iconClass: "mdi mdi-checkbox-multiple-marked-outline",
              iconChildren: "",
              iconTag: "i",
            },
            rtl: false,
          });
          this.$store.dispatch("Locker");
          this.unlockingAttempt = false;
          this.enteredPinCode = null;
        }
      } catch (error) {
        console.log(error);
        await this.$store.dispatch("errorAction", "Please Enter Correct Pin Code", {
          root: true,
        });
      } finally {
        this.$store.dispatch("setloading", false);
      }
    },
    unlockClickLift() {
      clearTimeout(this.timer);
      clearInterval(this.counter);
      this.timer = null;
      this.counter = null;
      this.radialValue = 0;
    },
    // loginUser(uuid) {
    //   const UID = uuid;
    //   const authKey = process.env.VUE_APP_COMET_CHAT_APP_AUTH_KEY;

    //   CometChat.getLoggedinUser().then(
    //     (user) => {
    //       if (!user) {
    //         CometChat.login(UID, authKey).then(
    //           (user) => {
    //             console.log("Login Successful");
    //           },
    //           (error) => {
    //             console.log("-auth:", authKey, "-----uid:", uuid, "----------Login failed with exception:", { error });
    //           }
    //         );
    //       }
    //     },
    //     (error) => {
    //       console.log("Something went wrong", error);
    //     }
    //   );

    //   let usersRequest = new CometChat.UsersRequestBuilder()
    //     .friendsOnly(true)
    //     .build();
    // },
  },
  created() {
    // this.testHash();
    // if (window.location.hash) {
    //   this.testHash();
    //   console.log(window.location.hash , "hash") ;
    // }
    window.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !this.$store.getters.getLocker) {
        this.spaceChecker = true;
        this.$store.dispatch("Locker");
      }
      if (event.key === " " && this.$store.getters.getLocker) {
        if (this.spaceChecker) this.unlockHold();
        this.spaceChecker = false;
      }
    });

    this.$store.subscribe((mutation, state) => {
      if (
        mutation.type === "setUser" &&
        mutation.payload.data.token !== null &&
        mutation.payload.data.uuid !== null
      ) {
        // this.loginUser(mutation.payload.data.uuid);
      }
    });
  },
  mounted() {
    if (this.$store.getters.SpotifyAccessToken) {
      document.addEventListener("click", () => {
        this.userInteraction = true;
      });
    } else {
      this.userInteraction = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.text-red:deep(input:-webkit-autofill),
.text-red:deep(input:-webkit-autofill:hover),
.text-red:deep(input:-webkit-autofill:focus) {
  -webkit-text-fill-color: #fff !important;
  -webkit-box-shadow: 0 0 0px 40rem #212121 inset !important;
}

.mobileNavBtn {
  position: absolute !important;
  right: 6%;
  top: 6%;
  z-index: 999;
}

.otp_verify:deep(.v-text-field__slot) {
  // background: linear-gradient(350deg,
  //     rgba(157, 115, 31, 1) 0%,
  //     rgba(219, 182, 112, 1) 50%,
  //     rgba(157, 115, 31, 1) 100%);
  border: 1px solid black;
  border-radius: 10px;
}

.otp_verify:deep(.v-input__slot fieldset) {
  border: none !important;
}

.otp_verify:deep(.v-input__slot) {
  border-radius: 10px !important;
}

.straight-BG {
  background: rgb(220, 193, 135);
  background: linear-gradient(
    90deg,
    rgba(220, 193, 135, 1) 0%,
    rgba(175, 138, 52, 1) 33%,
    rgba(213, 183, 124, 1) 58%,
    rgba(173, 138, 53, 1) 90%,
    rgba(204, 169, 102, 1) 100%
  );
}

.lesbian-BG {
  background: rgb(94, 1, 117);
  background: linear-gradient(
    73deg,
    rgba(94, 1, 117, 1) 0%,
    rgba(127, 0, 142, 1) 52%,
    rgba(161, 51, 246, 1) 100%
  );
}

.gay-BG {
  background: rgb(0, 240, 255);
  background: linear-gradient(39deg, rgba(0, 240, 255, 1) 0%, rgba(0, 156, 255, 1) 100%);
}

.floatingPlayer {
  position: absolute;
  z-index: 98;
  bottom: 0%;
  right: 5%;
  max-width: 440px;
}

.lockButton {
  position: absolute;
  z-index: 99;
  bottom: 3%;
  right: 6%;
}

.skipButton {
  z-index: 100;
  position: absolute;
  bottom: 5%;
  right: 5%;
}

.swipeRight {
  animation: ease-out infinite swipeRightAnimation 2s;
}

.swipeLeft {
  animation: ease-out infinite swipeLeftAnimation 2s;
}

.swipeBoth {
  animation: ease-in-out infinite swipeBothAnimation 5s;
}

@keyframes swipeRightAnimation {
  from {
    transform: translateX(0%);
  }

  to {
    transform: translateX(200%);
  }
}

@keyframes swipeLeftAnimation {
  from {
    transform: translateX(0%);
  }

  to {
    transform: translateX(-200%);
  }
}

@keyframes swipeBothAnimation {
  0% {
    transform: translate(0%);
  }

  25% {
    transform: translate(-200%);
  }

  75% {
    transform: translate(200%);
  }

  100% {
    transform: translate(0%);
  }
}
</style>
